<header class="flex header">
  <h2>
    {{ 'Adjust_Weight' | translateWF: 'Adjust Weight' }}
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" [disabled]="isLoading" />
</header>

@if (isLoading) {
  <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
}

<section class="content">
  <p-card>
    <div class="col">
      <div class="form-box">
        <label for="manualWeight">{{ 'weightStationDetails.enterWeight' | translateWF: 'Enter Weight (Lbs)' }}</label>
        <input
          pInputText
          type="number"
          id="manualWeight"
          class="w-full"
          [(ngModel)]="manualWeightValue"
          [max]="MaxWeight"
          min="0.01"
          step="0.01"
          placeholder="Enter weight manually"
          [class.ng-invalid]="submittedForm && (manualWeightValue <= 0 || manualWeightValue > MaxWeight)"
          [class.ng-dirty]="submittedForm && (manualWeightValue <= 0 || manualWeightValue > MaxWeight)"
        />
        <small class="text-orange-600 font-semibold">Maximum allowed: {{ MaxWeight | number: '1.2-2' }} lbs</small>
        <small class="text-gray-500">{{ 'weightStationDetails.weightControl' | translateWF: 'Weight control' }}</small>
      </div>
    </div>
  </p-card>
</section>

<footer>
  <p-button class="w-full" [label]="'Common_Save' | translateWF: 'Save'" (click)="onSave()" [disabled]="isLoading || manualWeightValue <= 0 || manualWeightValue > MaxWeight" />
  <p-button class="w-full" [label]="'Common_Exit' | translateWF: 'Exit'" variant="outlined" (click)="onClose()" [disabled]="isLoading" />
</footer>
